<div
  class="fullwidth fullheight flex-column-centered justify-content-center align-content-centerd align-items-center"
  style="height: 100vh"
>
  <h1>Wordpress oldal</h1>
  <p>Ez a link a Wordpress oldalra fog navigálni produkciós környezetben</p>
</div>
